import { useWindowSize } from 'hooks/useWindowSize';
import Flickity from 'react-flickity-component';
import { isMobileWidth } from 'utils/helpers';
import { BlocksMediaType, MediaBlock } from '../mediaBlock/MediaBlock';

import style from './GalleryBlock.module.scss';

export type BlocksGalleryType = {
  block_type: 'gallery';
  gallery_style: 'two' | 'three';
  items: BlocksMediaType[];
};

export const GalleryBlock = ({ items, gallery_style }: BlocksGalleryType): JSX.Element => {
  const windowSize = useWindowSize();
  const isMobileScreen = isMobileWidth(windowSize.width);

  const slideSize = gallery_style === 'three' ? style.slideIsThirdWindowWidth : null;
  const images = items.map((mediaItem, index) => {
    const mobile = mediaItem.phone_image
      ? {
          src: mediaItem.phone_image,
          width: mediaItem.phone_image_width,
          height: mediaItem.phone_image_height,
        }
      : undefined;
    const stickyProps = { top: `${index * 10}px` };

    return (
      <div className={`${style.slide} ${slideSize}`} key={index}>
        <MediaBlock {...mediaItem} block_type={'media'} />
        {/* <ImageBlock
          loadColor={mediaItem.loadColor}
          desktop={{
            src: mediaItem.image,
            width: mediaItem.image_width,
            height: mediaItem.image_height,
          }}
          mobile={mobile}
          alt={mediaItem.alt_text}
        /> */}
      </div>
    );
  });
  const pageDots = images.length > (slideSize === 'three' ? 3 : 2);
  return (
    <>
      <div className={`${style.viewport} block-gallery ${pageDots ? 'has-dots' : ''}`}>
        {/* DEV NOTE: due to a bug in flickity/react (?) using the 'watchCSS' methid doesn't render any children when rendered on a disabled state first */}
        {isMobileScreen ? (
          <div>{images}</div>
        ) : (
          <>
            {/* @ts-ignore */}
            <Flickity
              className={style.carousel}
              options={{
                pageDots: pageDots,
                prevNextButtons: false,
                // @ts-ignore : docs show we can use a string, the type is incorrect
                draggable: '>1',
                groupCells: '100%',
                contain: true,
                // watchCSS: true,
              }}
            >
              {images}
            </Flickity>
          </>
        )}
      </div>
    </>
  );
};
